
export const authSlice = (set,get) => ({
    token:null,
    isAuthenticated:false,
    smsGateway:0,
    setSmsGateway : (boolval) => set((state)=>({smsGateway:boolval})),
    setIsAuthenticate : (boolval) =>set((state)=>({isAuthenticated:boolval})),
    setToken : (newToken) =>set((state)=>({token:newToken})),

    logout :() =>{
        set({token:null,user:null,isAuthenticated:false,smsGateway:0,userInfo:null,selectedUser:null,todaysAppointment:null,clinicId:null});
    },
})
